module.exports = __webpack_public_path__ + "assets/icons/thumb-up.png";


//////////////////
// WEBPACK FOOTER
// ./src/styles/icons/emojies/thumb-up.png
// module id = ./src/styles/icons/emojies/thumb-up.png
// module chunks = 0